import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { Logo } from './Logo';
const COLUMNS = [{
  title: 'Services',
  links: [{
    label: 'Interior Remodeling',
    href: '#services'
  }, {
    label: 'Exterior Improvements',
    href: '#services'
  }, {
    label: 'Kitchens & Baths',
    href: '#services'
  }, {
    label: 'Cabinetry & Built-Ins',
    href: '#services'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'Selected Work',
    href: '#work'
  }, {
    label: 'Our Process',
    href: '#process'
  }, {
    label: 'About Us',
    href: '#about'
  }, {
    label: 'Contact',
    href: '#contact'
  }]
}];
export function SiteFooter() {
  return <footer className="w-full border-t border-white/10 bg-pine-950 py-16" data-id="element-170" data-mp="20x9dpre6i0ag">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-171" data-mp="20z2l58wm8oji">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-172" data-mp="1wumh7d6kbr6x">
          <div className="lg:col-span-5" data-id="element-173" data-mp="1wxh0v2hr57za">
            <Logo height={40} data-id="element-174" data-mp="1rxmar15swmfa" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-bone-100/55" data-id="element-175" data-mp="1rxcui5ak5tms">
              Full-service general contracting — interior and exterior
              remodeling, built to last and finished with care.
            </p>
            <address className="mt-6 space-y-2 text-sm not-italic text-bone-100/70" data-id="element-176" data-mp="2q8s2kmtyvrcg">
              <a href="https://maps.google.com/?q=2724+Meadowbrook+Dr+SE+Cedar+Rapids+IA+52403" target="_blank" rel="noreferrer" className="block transition-colors hover:text-bone-50" data-id="element-177" data-mp="2q6yy9e6ttj7m">
                2724 Meadowbrook Dr SE, Cedar Rapids, IA 52403
              </a>
              <a href="tel:+15633809640" className="block transition-colors hover:text-bone-50" data-id="element-178" data-mp="38y87rnglk7z7">
                (563) 380-9640
              </a>
              <a href="mailto:TaylorCompany.co@gmail.com" className="block break-all transition-colors hover:text-bone-50" data-id="element-179" data-mp="1xjuxxmioht26">
                TaylorCompany.co@gmail.com
              </a>
            </address>
            <div className="mt-6 flex items-center gap-3" data-id="element-180" data-mp="853kehze4sey">
              <a href="https://www.instagram.com/taylorcompanyy/" target="_blank" rel="noreferrer" aria-label="Taylor Company on Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-bone-100/70 transition-colors hover:border-white/50 hover:text-bone-50" data-id="element-181" data-mp="357cw8rhiiun">
                <Instagram className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="3gi11f428775g" />
              </a>
              <a href="https://www.facebook.com/taylorcompany.co" target="_blank" rel="noreferrer" aria-label="Taylor Company on Facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-bone-100/70 transition-colors hover:border-white/50 hover:text-bone-50" data-id="element-183" data-mp="3bkr1uvl4hf3w">
                <Facebook className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="2nnbb6dit2ryv" />
              </a>
            </div>
            <p className="mt-6 text-[11px] uppercase tracking-[0.16em] text-bone-100/40" data-id="element-185" data-mp="2smfj70tzujnm">
              Licensed & Insured · Locally Owned
            </p>
          </div>

          {COLUMNS.map(column => <nav key={column.title} aria-label={column.title} className="lg:col-span-3" data-id="element-186" data-mp="31ehhasglbnuq">
              <h2 className="text-[11px] uppercase tracking-widest2 text-bone-100/45" data-id="element-187" data-mp="29olcwuk92m8x">
                {column.title}
              </h2>
              <ul className="mt-6 space-y-3" role="list" data-id="element-188" data-mp="2dp58htp6dhsy">
                {column.links.map(link => <li key={link.label} data-id="element-189" data-mp="2iqcebn7rc6wz">
                    <a href={link.href} className="text-sm text-bone-100/70 transition-colors hover:text-bone-50" data-id="element-190" data-mp="2in6twla2pt7l">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-191" data-mp="3nopxpsaaa319">
          <p className="text-xs text-bone-100/40" data-id="element-192" data-mp="5k4qf8mmodav">
            © {new Date().getFullYear()} Taylor Company. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-6" data-id="element-193" data-mp="fgr8jpnkkq97">
            <a href="tel:+15633809640" className="text-xs text-bone-100/50 transition-colors hover:text-bone-50" data-id="element-194" data-mp="ffg5js1y7mj5">
              (563) 380-9640
            </a>
            <a href="mailto:TaylorCompany.co@gmail.com" className="text-xs text-bone-100/50 transition-colors hover:text-bone-50" data-id="element-195" data-mp="p597s2g7apaq">
              TaylorCompany.co@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>;
}